/**
 * §6.3 — v1 stores citizen media EXACTLY as recorded, with no transcoding.
 * `video/webm` and `audio/ogg;codecs=opus` play natively in Chrome, Edge and
 * Firefox but **not in Safari**, so the panel is specified as Chrome/Edge, warns
 * anywhere else, and always offers a Download button next to the player.
 *
 * This is a warning, never a block: a handler on the wrong browser must still be
 * able to download the recording and do their job.
 */

interface UserAgentBrand {
  brand: string;
  version: string;
}

interface NavigatorUAData {
  brands?: UserAgentBrand[];
}

const SUPPORTED_BRANDS = ['Google Chrome', 'Microsoft Edge', 'Chromium'];

export function isSupportedMediaBrowser(): boolean {
  const uaData = (navigator as Navigator & { userAgentData?: NavigatorUAData }).userAgentData;
  if (uaData?.brands?.length) {
    return uaData.brands.some((entry) => SUPPORTED_BRANDS.includes(entry.brand));
  }

  // Fallback for browsers without the UA-CH API (notably Safari and Firefox).
  const ua = navigator.userAgent;
  const isChromium = /\b(Chrome|Chromium|Edg)\//.test(ua);
  const isSafari = /Safari\//.test(ua) && !isChromium;
  return isChromium && !isSafari;
}
